import { LoadingState } from '@sportik/ui/components/LoadingState';
import {
  SidebarInset,
  SidebarProvider,
  SidebarTrigger,
} from '@sportik/ui/primitives/sidebar';
import { TooltipProvider } from '@sportik/ui/primitives/tooltip';
import type { CSSProperties } from 'react';
import { Outlet, useNavigation } from 'react-router';
import { AppSidebar } from './AppSidebar';

// The sidebar primitive writes its open state to this cookie on every toggle;
// reading it back is all the persistence this shell needs.
function readSidebarState() {
  return !document.cookie
    .split('; ')
    .some((entry) => entry === 'sidebar_state=false');
}

/** The coach shell: the nav rail and the page frame every route renders in. */
export function AppLayout() {
  const navigation = useNavigation();

  return (
    <TooltipProvider>
      <SidebarProvider
        defaultOpen={readSidebarState()}
        style={{ '--sidebar-width': '15rem' } as CSSProperties}
      >
        <AppSidebar />
        <SidebarInset>
          <SidebarTrigger
            className="m-2 md:hidden"
            aria-label="Open navigation"
          />
          {/* The one pending indicator (ADR 0016): the page being left stays
              on screen until the next one has its code and its awaited reads.
              Out of flow, so nothing shifts when it comes and goes. */}
          {navigation.state === 'idle' ? null : (
            <LoadingState className="pointer-events-none absolute inset-x-0 top-0 p-1.5" />
          )}
          <div className="mx-auto flex w-full max-w-screen-2xl min-w-0 flex-1 flex-col gap-5 p-8">
            <Outlet />
          </div>
        </SidebarInset>
      </SidebarProvider>
    </TooltipProvider>
  );
}
